import { DATA_SOURCE } from "../../../../util/Data/DataModeling";

// Status Types considering all the jobs
export const Job_Status_Types = {
  running: { statusCode: 1, color: "black", statusText: "Running" },
  waiting: { statusCode: 2, color: "black", statusText: "Waiting" },
  paused: { statusCode: 3, color: "black", statusText: "Paused" },
  terminated: { statusCode: 4, color: "blue", statusText: "Terminated" },
  success: { statusCode: 5, color: "green", statusText: "Success" },
  failed: { statusCode: 6, color: "red", statusText: "Failed" },
  error: { statusCode: 6, color: "red", statusText: "Failed" },
  draft: { statusCode: 7, color: "black", statusText: "Draft" },
  skipped: { statusCode: 8, color: "black", statusText: "Skipped" },
  warning: { statusCode: 9, color: "orange", statusText: "Warning" },
  partially: { color: "orange", statusText: "Partially Loaded" },
  missing: { color: "orange", statusText: "Missing" },
};

//rows per page options (default)
export const rowsPerPageOptions = [10, 25, 50, 100];

// Common Columns for all jobs (split panel)
export const Columns = [
  { id: "StartTime", label: "Start Time", width: "25%", align: "left", sortable: true, type: "date" },
  { id: "EndTime", label: "End Time", width: "25%", align: "left", sortable: true, type: "date" },
  { id: "Status", label: "Status", width: "15%", align: "left", sortable: true },
  { id: "Comments", label: "Comments", width: "35%", align: "left", sortable: false },
];

// Specific to JobHistory popup on schedule job
export const JobHistoryColumns = [
  { id: "StartTime", label: "Start Time", width: "100px", align: "left", sortable: true, type: "date" },
  { id: "EndTime", label: "End Time", width: "100px", align: "left", sortable: true, type: "date" },
  { id: "Status", label: "Status", width: "80px", align: "left", sortable: true },
  { id: "Comments", label: "Comments", width: "480px", align: "left", sortable: false },
];

// Detailed History Columns for Data modeling
export const Detailed_Columns = [
  { id: "STORED_PROCEDURE", label: "Stored Procedure", width: "140px", align: "left", sortable: true },
  { id: "STEP", label: "Step", width: "150px", align: "left", sortable: true },
  { id: "RESULT", label: "Result", width: "300px", align: "left", sortable: true },
  {
    id: "STATUS",
    label: "Status",
    width: "80px",
    align: "left",
    sortable: true,
  },
  { id: "LOAD_DATE", label: "Time", width: "100px", align: "left", sortable: true, type: "date" },
];

// Specific to JobHistory popup on schedule job
export const PipelineHistoryColumns = [
  { id: "Name", label: "Entry Point", width: "110px", align: "left", sortable: true },
  { id: "Status", label: "Status", width: "80px", align: "left", sortable: true },
  { id: "StartTime", label: "Start Time", width: "110px", align: "left", sortable: true, type: "date" },
  { id: "EndTime", label: "End Time", width: "110px", align: "left", sortable: true, type: "date" },
  { id: "Jobs", label: "Jobs", width: "70px", align: "right", sortable: true },
  { id: "RunBy", label: "Initiator", width: "100px", align: "left", sortable: true },
];

// Detailed History Columns for Data modeling
export const Detailed_Pipeline_Columns = [
  { id: "Name", label: "Job", width: "120px", align: "left", sortable: true },
  { id: "Status", label: "Status", width: "80px", align: "left", sortable: true },
  { id: "StartTime", label: "Start Time", width: "100px", align: "left", sortable: true, type: "date" },
  { id: "EndTime", label: "End Time", width: "100px", align: "left", sortable: true, type: "date" },
  { id: "message", label: "Comment", width: "80px", align: "left", sortable: false },
];

export const JOB_BY_TYPE = {
  dataLoad: 1,
  dataExchange: 2,
  dataTransform: 3,
  dataQuality: 4,
  dataMastering: 5,
  dataDeduplication: 6,
  notebook: 7,
  routing: 8,
  notification: 9,
};

// all Types of Jobs
export const JOB_TYPES = [
  { type: 1, Name: "Data Load", path: "data-load", kmkEnabled: false },
  { type: 4, Name: "Data Quality", path: "data-quality", kmkEnabled: false },
  { type: 5, Name: "Data Mastering", path: "mdm", kmkEnabled: false },
  { type: 6, Name: "Data Deduplication", path: "data-deduplication", kmkEnabled: false },
  { type: 2, Name: "Data Exchange", path: "data-exchange", kmkEnabled: true },
  { type: 3, Name: "Data Transform", path: "data-transform", kmkEnabled: true },
  { type: 7, Name: "Notebook", path: "notebook", kmkEnabled: true },
  { type: 8, Name: "Routing", path: "routing", kmkEnabled: true },
  { type: 9, Name: "Notification", path: "notification", kmkEnabled: true },
];

export const JOBS = [
  { id: 1, Name: "Data Load" },
  { id: 2, Name: "Data Exchange" },
  { id: 3, Name: "Data Transform" },
  { id: 4, Name: "Data Quality" },
  { id: 5, Name: "Data Modeling" },
  { id: 6, Name: "Data Deduplication" },
  { id: 7, Name: "Notebook" },
  { id: 8, Name: "Routing" },
  { id: 9, Name: "Notification" },
];

// all Types of Jobs
export const TABS_BY_JOB_TYPE = {
  1: [
    { id: "Name", label: "Name", fieldsToCompare: ["name", "DataPipeline_id", "description"] },
    { id: "DataSets", label: DATA_SOURCE.plural, fieldsToCompare: ["dataSets"] },
    { id: "Schedule", label: "Schedule", fieldsToCompare: ["scheduleEnabled", "schedule"] },
    { id: "Runtime", label: "Runtime", fieldsToCompare: ["cluster"] },
    { id: "History", label: "History" },
  ],
  4: [
    { id: "Name", label: "Name", fieldsToCompare: ["name", "DataPipeline_id", "description"] },
    { id: "DataSets", label: DATA_SOURCE.plural, fieldsToCompare: ["dataSets"] },
    { id: "DataQuality", label: "Data_Quality", fieldsToCompare: ["query"] },
    { id: "Schedule", label: "Schedule", fieldsToCompare: ["scheduleEnabled", "schedule"] },
    { id: "Runtime", label: "Runtime", fieldsToCompare: ["cluster"] },
    { id: "History", label: "History" },
  ],
  5: [
    { id: "Name", label: "Name", fieldsToCompare: ["name", "DataPipeline_id", "description"] },
    { id: "Entities", label: "Entities", fieldsToCompare: ["dataSets"] },
    { id: "Schedule", label: "Schedule", fieldsToCompare: ["scheduleEnabled", "schedule"] },
    { id: "Runtime", label: "Runtime", fieldsToCompare: ["cluster"] },
    { id: "History", label: "History" },
  ],
  6: [
    { id: "Name", label: "Name", fieldsToCompare: ["name", "DataPipeline_id", "description"] },
    { id: "Entities", label: "Entities", fieldsToCompare: ["dataSets"] },
    { id: "Schedule", label: "Schedule", fieldsToCompare: ["scheduleEnabled", "schedule"] },
    { id: "Runtime", label: "Runtime", fieldsToCompare: ["cluster"] },
    { id: "History", label: "History" },
  ],
  2: [
    { id: "Name", label: "Name", fieldsToCompare: ["name", "DataPipeline_id", "description"] },
    {
      id: "Action",
      label: "Action",
      fieldsToCompare: [
        "sourceType",
        "bucket",
        "sourcePath",
        "source",
        "targetPath",
        "destination",
        "docuList",
        "delimiter",
        "customDelimeter",
        "hasHeaderRow",
        "encoding",
        "fieldEnclosedBy",
        "groupBy",
        "schemaName",
        "tableName",
        "destinationAction",
        "existingTableAction",
        "fields",
        "query",
        "filename",
        "fileType",
        "resetFiles",
        "onError",
        "onErrorNumber",
        "nullValue",
        "customNullValue",
        "jobPurpose",
        "conversionFrom",
        "externalIdFieldName",
        "regexMatchPattern",
        "regexReplacePattern",
      ],
    },
    { id: "Schedule", label: "Schedule", fieldsToCompare: ["scheduleEnabled", "schedule"] },
    { id: "Runtime", label: "Runtime", fieldsToCompare: ["runJobAsUserId"] },
    { id: "History", label: "History" },
  ],
  3: [
    { id: "Name", label: "Name", fieldsToCompare: ["name", "DataPipeline_id", "description"] },
    {
      id: "Transform",
      label: "Transform",
      fieldsToCompare: ["Type", "query", "database", "schema", "location"],
    },
    { id: "Schedule", label: "Schedule", fieldsToCompare: ["scheduleEnabled", "schedule"] },
    {
      id: "Runtime",
      label: "Runtime",
      fieldsToCompare: ["cluster", "runJobAsUserId"],
    },
    { id: "History", label: "History" },
  ],
  7: [
    { id: "Name", label: "Name", fieldsToCompare: ["name", "DataPipeline_id", "description"] },
    {
      id: "Notebook",
      label: "Target",
      fieldsToCompare: ["type", "jobPipeline"],
    },
    { id: "Schedule", label: "Schedule", fieldsToCompare: ["scheduleEnabled", "schedule"] },
    {
      id: "Runtime",
      label: "Runtime",
      fieldsToCompare: [],
    },
    { id: "History", label: "History" },
  ],
  8: [
    { id: "Name", label: "Name", fieldsToCompare: ["name", "DataPipeline_id", "description"] },
    {
      id: "Condition",
      label: "Condition",
      fieldsToCompare: ["Type", "query", "database", "schema", "location"],
    },
    { id: "Schedule", label: "Schedule", fieldsToCompare: ["scheduleEnabled", "schedule"] },
    {
      id: "Runtime",
      label: "Runtime",
      fieldsToCompare: ["cluster", "runJobAsUserId"],
    },
    { id: "History", label: "History" },
  ],
  9: [
    { id: "Name", label: "Name", fieldsToCompare: ["name", "DataPipeline_id", "description"] },
    {
      id: "EmailContent",
      label: "Email Content",
      fieldsToCompare: ["subject", "emails", "body"],
    },
    {
      id: "AdditionalData",
      label: "Additional Data Sections (optional)",
      fieldsToCompare: [
        "location",
        "database",
        "schema",
        "includeResult",
        "queryResultAs",
        "query",
        "Cluster",
        "runJobAsUserId",
      ],
    },
    { id: "Schedule", label: "Schedule", fieldsToCompare: ["scheduleEnabled", "schedule"] },
    {
      id: "Runtime",
      label: "Runtime",
      fieldsToCompare: [],
    },
    { id: "History", label: "History" },
  ],
};

export const MESSAGES = {
  DataPipeline: {
    EditPanelOpen: "Please save the current job before making any changes in the pipeline.",
  },
  EditPanel: {
    EditUnSavedChanges: "You have unsaved changes, Are you sure you want to close the panel?",
    CreateUnSavedChanges: "You have unsaved job or changes, Are you sure you want to close the panel?",
  },
};

export const OBJECT_TYPE_ROUTES = {
  1: "data-sources",
  2: "entities",
};

export const DETAUL_CRON_VALUE = "0 0 * * 1";

export const JOB_PURPOSE_CONVERSION = "CONVERSION";
export const JOB_PURPOSE_EXCHANGE = "EXCHANGE";

export const JOB_PURPOSES = [
  { Id: JOB_PURPOSE_CONVERSION, Label: "File Conversion" },
  { Id: JOB_PURPOSE_EXCHANGE, Label: "Import / Export" },
];

export const CONVERSION_FROM_SAS = "SAS7BDAT";
const CONVERSION_FROM_EXCEL = "XLSX";

export const CONVERSION_OPTIONS = [
  { Id: CONVERSION_FROM_SAS, Label: "SAS7BDAT" },
  { Id: CONVERSION_FROM_EXCEL, Label: "XLSX" },
];

export const browserStateVar = {
  sftp: "sftpBrowser",
  azure: "azureBrowser",
  sharepoint: "spBrowser",
  s3: "s3Browser",
};
